import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Serviço centralizado para gerenciar feature flags da aplicação.
 *
 * Feature Flags para Upload Estendido (KML/Excel):
 * - Quando flag = false: apenas Shapefile é permitido (comportamento antigo/seguro)
 * - Quando flag = true: permite Shapefile + KML + Excel (comportamento novo)
 *
 * Uso nos componentes:
 * ```typescript
 * constructor(private featureFlags: FeatureFlagsService) {}
 *
 * // No template ou TS
 * const enabledTypes = this.featureFlags.isComplianceExtendedUploadEnabled()
 *   ? ['shapefile', 'spreadsheet', 'kml']
 *   : ['shapefile'];
 * ```
 */
@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  /**
   * Retorna os tipos de arquivo permitidos para o módulo Compliance.
   * @returns Array com tipos de arquivo permitidos
   */
  getComplianceEnabledFileTypes(): ('shapefile' | 'spreadsheet' | 'kml')[] {
    return ['shapefile', 'spreadsheet', 'kml'];
  }

  /**
   * Retorna os tipos de arquivo permitidos para o módulo Histórico.
   * @returns Array com tipos de arquivo permitidos
   */
  getHistoricoEnabledFileTypes(): ('shapefile' | 'spreadsheet' | 'kml')[] {
    return ['shapefile', 'spreadsheet', 'kml'];
  }

  /**
   * Retorna os tipos de arquivo permitidos para o módulo Monitoramento.
   * @returns Array com tipos de arquivo permitidos
   */
  getMonitoramentoEnabledFileTypes(): ('shapefile' | 'spreadsheet' | 'kml')[] {
    return ['shapefile', 'spreadsheet', 'kml'];
  }
}
